<template>    
    <div class="myConBot" v-if="info">                
        <van-row class="myConTimTitle" v-if="todayIsTransdate">
            <van-col span="12">
                {{info.transDate | dataFormat('MM月dd日')}}
            </van-col>
            <van-col span="12" class="ta-right">盈亏情况</van-col>
            <van-col span="12" class="myConTimCon">
                <span v-if="info.upDown == 0">涨跌结果 待公布</span>
                <span v-else>涨跌结果 <k-text :type="info.upDown" skin="1" /></span>                
            </van-col>
            <van-col span="12" class="myConTimCon ta-right"  v-if="myBetInfo">
                    <span v-if="info.upDown == 0">待公布</span>
                    <template v-else-if="info.upDown == info.betType">
                        <span class="upColor">+</span><span class="upColor">{{info.rewardGold}}</span>
                    </template>
                    <template v-else>
                        <span>-</span><span class="downColor">{{info.betNum * 100}}</span>
                    </template>
            </van-col>
        </van-row>
        <div class="myPutDown">
            <div class="myPutDownWrap">
                <p :class="+info.betType===1?'myPutUpConLeft':(+info.betType===2?'myPutDownConLeft':'')">
                    <k-text :type="info.betType " class="fts-30" /> 
                    <span>{{info.ctime}}</span>
                </p>
                <p class="myPutUpConRight" :class="+info.betType===1?'up':(+info.betType===2?'down':'')">
                    <span>{{info.betNum}}</span><span>注(</span><k-num :value="info.betNum*100" /><span>金币)</span>
                </p>
            </div>            
        </div>
    </div>    
</template>
<script>
    import {mapGetters} from 'vuex'
    export default {
        props : ['info'],
        data() {
            return {
                
            }
        },
        computed: {
            ...mapGetters(['myInfo','myUid','myNick','myLogo']),
            ...mapGetters('home', ['myBetDetail', 'transDate', 'nowTime', 'tomorrow', 'todayIsTransdate', 'myBetInfo']),
        },
        methods: {
            
        },
        watch:{
            myBetInfo(){

            }
        }
    }
</script>